// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"548a6be3","488":"d999adae","977":"86c63df0"}[chunkId] + ".chunk.js";
};